import React, { createElement, Fragment, useEffect } from "react";
// import { useNavigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import qs from 'qs';

import { useAppContext } from "../context/context";
import { generateContent, generateCss, generateEvent, generateSrc, generateStyle } from "../functions/sortableFunctions";

import CircleLoader from "./CircleLoader";

// Animation
import ScrollAnimations from "./Interface/ScrollAnimations";
import CircularText from "./Interface/CircularText";
import TypingAnimation from "./Interface/TypingAnimation";
import ParallaxAnimations from "./Interface/ParallaxAnimations";

// Popover
import PopoverComponent from "./Interface/PopoverComponent";
import PopoverButton from "./Interface/PopoverButton";
import PopoverPanel from "./Interface/PopoverPanel";

// Disclosure
import DisclosureComponent from "./Interface/Disclosure";
import DisclosureButton from "./Interface/DisclosureButton";
import DisclosurePanel from "./Interface/DisclosurePanel";

// Tab
import TabGroup from "./Interface/TabGroup";
import TabList from "./Interface/TabList";
import Tab from "./Interface/Tab";
import TabPanels from "./Interface/TabPanels";
import TabPanel from "./Interface/TabPanel";

// Navigate
import LinkComponent from "./Interface/Link";
import AComponent from "./Interface/A";

// Form
import Form from "./Interface/Form";
import Input from "./Interface/Input";
import Field from "./Interface/Field";

// Logical Components
import LogicalAnd from "./Interface/LogicalAnd";
import Ternary from "./Interface/Ternary";
import Loop from "./Interface/loop";

// Carousel
import CarousalComponent from "./Interface/Carousal";
import DynamicCarousel from "./Interface/dynamicCarousel";

// Map
import GoogleMap from "./Interface/GoogleMap";
import FetchLocationMap from "./Interface/FetchLocationMap";

import Video from "./Interface/Video";
import TimerPopup from "./Interface/TimerPopup";
import DynamicComponent from "./Interface/DynamicComponent";
import Seo from "./Interface/Seo";
import Html from "./Interface/html";

export default function PreviewRsortable({ blocks, ...props }: any) {

  const contextVariables: any = useAppContext();

  // const params = useParams();
  // const location = useLocation();
  // const navigate = useNavigate();
  // const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    // console.log('props.user in package', props.user);
    contextVariables.setUser(props.user ?? null);
  }, [props.user]);

  return (
    <React.Fragment>
      {blocks?.map((block: any, index: any) => (
        <BlockWrapper
          {...props}
          key={index}
          block={block}
          contextVariables={contextVariables}
          // params={params}
          // location={location}
          // navigate={navigate}
          // searchParams={searchParams}
          // setSearchParams={setSearchParams}
          qs={qs}
        />
      ))}
    </React.Fragment>
  );
}

export function BlockWrapper({ block, ...props }: any) {

  // START - Animation

  if (block?.data?.animationOnScroll === true && block?.data?.animateInfinite === false) {    // For scroll animation without infinite loop
    return <ScrollAnimations {...props} block={block} />;
  }
  else if (block?.data?.isCircularText == true) {
    return <CircularText {...props} block={block} />;
  }
  else if (block?.data?.isTypingEffect == true) {
    return <TypingAnimation {...props} block={block} />;
  }
  else if (block?.data?.isParallax === true) {
    return <ParallaxAnimations {...props} block={block} />;
  }

  // END - Animation


  // START - Popover

  else if (block.type === "Popover") {
    return <PopoverComponent  {...props} block={block} />
  }
  else if (block.type == "PopoverButton") {
    return <PopoverButton {...props} block={block} />
  }
  else if (block.type == "PopoverPanel") {
    return <PopoverPanel {...props} block={block} />
  }

  // END - Popover


  // START - Disclosure

  else if (block.type == "Disclosure") {
    return <DisclosureComponent {...props} block={block} />
  }
  else if (block.type == "DisclosureButton") {
    return <DisclosureButton {...props} block={block} />
  }
  else if (block.type == "DisclosurePanel") {
    return <DisclosurePanel {...props} block={block} />
  }

  // END - Disclosure


  // START - Tab

  else if (block.type == "TabGroup") {
    return <TabGroup {...props} block={block} />
  }
  else if (block.type == "TabList") {
    return <TabList {...props} block={block} />
  }
  else if (block.type == "Tab") {
    return <Tab {...props} block={block} />
  }
  else if (block.type == "TabPanels") {
    return <TabPanels {...props} block={block} />
  }
  else if (block.type == "TabPanel") {
    return <TabPanel {...props} block={block} />
  }

  // END - Tab


  // START - Navigate

  else if (block.type == "Link") {
    return <LinkComponent {...props} block={block} />
  }
  else if (block.type == "a") {
    return <AComponent {...props} block={block} />
  }

  // END - Navigate


  // START - Form

  else if (block.type == "form") {
    return <Form {...props} block={block} />
  }
  else if ((block?.type === 'input' || block?.type === 'select' || block?.type === 'textarea') && !block?.data?.withoutForm) {
    return <Input {...props} block={block} />
  }
  else if ((block?.type === 'input' || block?.type === 'select' || block?.type === 'textarea') && block?.data?.withoutForm && !props?.componentsPreview) {
    return <Field {...props} block={block} />
  }

  // END - Form


  // START - Logical Components

  else if (block.type == "LogicalAnd") {
    return <LogicalAnd {...props} block={block} />
  }
  else if (block.type == "Ternary") {
    return <Ternary {...props} block={block} />
  }
  else if (block.type == "loop") {
    //@ts-ignore
    return <Loop {...props} block={block} />
  }

  // END - Logical Components


  // START - Carousel

  else if (block.type == "carousel") {
    return <CarousalComponent {...props} block={block} />
  }
  else if (block.type == "dynamicCarousel") {
    return <DynamicCarousel {...props} block={block} />
  }

  // END - Carousel


  // START - Map

  else if (block.type == "GoogleMap") {
    return <GoogleMap {...props} block={block} />
  }

  else if (block.type == "FetchLocationMap") {
    return <FetchLocationMap {...props} block={block} />
  }

  // END - Map


  else if (block.type == "video") {
    return <Video {...props} block={block} />
  }

  else if (block.type === "TimerPopup") {
    return <TimerPopup {...props} block={block} />
  }

  else if (block.type == "dynamicComponent") {
    return <DynamicComponent {...props} block={block} />
  }

  else if (block.type == "Seo") {
    if (props.builderPreview || props.templatePreview || props.componentsPreview) return null;

    return <Seo {...props} block={block} />
  }

  else if (block.type == "html") {
    return <Html {...props} block={block} />
  }

  else {

    return (
      <Fragment>
        {
          createElement(
            block?.type,
            {
              key: block?.id,
              id: block?.id,
              // ...block.data,

              className: `${generateCss({
                props: {
                  ...props,
                  block
                },
              })} ${
                block?.data?.type === "submit" && props?.formik?.isSubmitting ? "!cursor-not-allowed !bg-[#D1D2D3]" : ""
              }`,

              style: generateStyle({
                props: {
                  ...props,
                  block
                }
              }),

              type: block?.data?.type ?? null,

              rows: block?.data?.rows ?? null,
              cols: block?.data?.cols ?? null,

              min: block?.data?.min ?? null,
              max: block?.data?.max ?? null,

              maxLength: block?.data?.maxLength ?? null,
              minLength: block?.data?.minLength ?? null,

              pattern: block?.data?.pattern ?? null,

              placeholder: block?.data?.placeholder ?? null,

              multiple: block?.data?.multiple ?? null,

              step: block?.data?.step ?? null,

              autoComplete: block?.data?.autoComplete ?? null,
              autoFocus: block?.data?.autoFocus ?? null,

              disabled: block?.data?.type == 'submit' ? props?.formik?.isSubmitting : false,

              value: block?.data?.value ?
                typeof block.data.value == 'object' ?
                  block.data.value.custom ?
                    eval(block.data.value.value) :
                    props.singleData?.[block.data.value.fieldName] :
                  block?.data?.value :
                null,

              src: generateSrc({
                props: {
                  ...props,
                  block: block
                },
                key: "src"
              }),

              alt: block?.data?.alt ?? null,

              onClick: block.events?.onClick ? async (e: any) => {
                await generateEvent({
                  props: {
                    ...props,
                    block: block
                  },
                  e: e,
                  event: "onClick"
                });
              } : null,

              onDoubleClick: block.events?.onDoubleClick ? async (e: any) => {
                await generateEvent({
                  props: {
                    ...props,
                    block: block
                  },
                  e: e,
                  event: "onDoubleClick"
                });
              } : null,

              onContextMenu: block.events?.onContextMenu ? async (e: any) => {
                await generateEvent({
                  props: {
                    ...props,
                    block: block
                  },
                  e: e,
                  event: "onContextMenu"
                });
              } : null,

              onMouseOver: block.events?.onMouseOver ? async (e: any) => {
                await generateEvent({
                  props: {
                    ...props,
                    block: block
                  },
                  e: e,
                  event: "onMouseOver"
                });
              } : null,

              onMouseLeave: block.events?.onMouseLeave ? async (e: any) => {
                await generateEvent({
                  props: {
                    ...props,
                    block: block
                  },
                  e: e,
                  event: "onMouseLeave"
                });
              } : null
            },
            block?.data?.type === "submit" && props?.formik?.isSubmitting ?
              // "Loading..."
              <CircleLoader />
            :
              block.children ?
                block?.children?.map((childBlock: any, index: any) => {
                  return (
                    <BlockWrapper
                      {...props}
                      key={index}
                      block={childBlock}
                    />
                  );
                })
              :
                generateContent({
                  props: {
                    ...props,
                    block: block
                  },
                })
          )
        }
      </Fragment>
    );
  }
}